import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('wunddok_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('wunddok_token');
      localStorage.removeItem('wunddok_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me', { headers: { authorization: `Bearer ${localStorage.getItem('wunddok_token')}` } }),
  changePassword: (data) => api.post('/auth/change-password', data),
};

// Patients
export const patientAPI = {
  list: (params) => api.get('/patients', { params }),
  archived: () => api.get('/patients/archived'),
  get: (id) => api.get(`/patients/${id}`),
  create: (data) => api.post('/patients', data),
  update: (id, data) => api.put(`/patients/${id}`, data),
  delete: (id) => api.delete(`/patients/${id}`),
  archive: (id) => api.post(`/patients/${id}/archive`),
  restore: (id) => api.post(`/patients/${id}/restore`),
  statistics: (id) => api.get(`/patients/${id}/statistics`),
};

// Wounds
export const woundAPI = {
  get: (id) => api.get(`/wounds/${id}`),
  create: (data) => api.post('/wounds', data),
  update: (id, data) => api.put(`/wounds/${id}`, data),
  delete: (id) => api.delete(`/wounds/${id}`),
  photos: (id) => api.get(`/wounds/${id}/photos`),
};

// Wound Reports
export const reportAPI = {
  get: (id) => api.get(`/wound-reports/${id}`),
  create: (data) => api.post('/wound-reports', data),
  update: (id, data) => api.put(`/wound-reports/${id}`, data),
  delete: (id) => api.delete(`/wound-reports/${id}`),
  byWound: (woundId) => api.get(`/wound-reports/by-wound/${woundId}`),
  latest: (woundId) => api.get(`/wound-reports/latest/${woundId}`),
  exportPdf: (id) => `${API_BASE}/export/wound-report/${id}`,
};

// Dashboard
export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats'),
};

// Upload
export const uploadAPI = {
  photo: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/upload/photo', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

// Seed
export const seedAPI = {
  seed: () => api.post('/seed-demo-data'),
};

// Admin
export const adminAPI = {
  users: () => api.get('/admin/users'),
  createUser: (data) => api.post('/admin/users', data),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
  auditLog: (params) => api.get('/admin/audit-log', { params }),
  importPatients: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/admin/import-patients', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
};

// Settings
export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

export default api;
